import React from "react";
import {inject, observer} from "mobx-react";
import DropDown from "../../dropDown/dropDown";
import {
    ClientCompanyLegalFormDropDown,
    ClientLegalGroup,
    ClientOtherLegalFormDropDown,
    ClientPrivateLegalFormDropDown,
    ClientModel
} from "../../../../helpers/client";
import { CalculateStore } from "../../../../stores/calculateStore";
import { runInAction } from "mobx";

interface FirstNameProps {
    calculateStore?: CalculateStore;
    client: ClientModel;
    disabled?: boolean;
}

export function LegalForm(props: FirstNameProps) {
    const calculateStore = props.calculateStore!;
    const client = props.client;
    const legalGroup = client.legalGroup;
    const legalForm = client.legalForm.value ?? "";
    const recalculateOnChange = client.insurer;

    return (
        <div className="legal-form">
            <div className="question-answer-container">
                <div className="question">Forma prawna</div>
                    <DropDown onChange={(val) => {
                        runInAction(() => {
                            // TODO: create setter and remove 'runInAction'
                            client.legalForm.value = val;
                        });
                        if (recalculateOnChange) {
                            calculateStore.setRequireRecalculate(true);

                        }
                        client.legalForm.validate();
                    }}
                              errorMessage={client.legalForm.errorMessage}
                              disabled={props.disabled}
                              value={legalForm as string}
                              items={getLegalFormsSuitableToLegalGroup(legalGroup)}
                    />
            </div>
        </div>
    );

    function getLegalFormsSuitableToLegalGroup(value: ClientLegalGroup) {
        switch (value) {
            case ClientLegalGroup.COMPANY:
                return ClientCompanyLegalFormDropDown;
            case ClientLegalGroup.OTHER:
                return ClientOtherLegalFormDropDown;
            default:
                return ClientPrivateLegalFormDropDown;
        }
    }
}

export default inject("calculateStore")(observer(LegalForm));
